module.exports = __webpack_public_path__ + "img/wko.89d27bf7.png";